import { render, staticRenderFns } from "./kadarrespon.vue?vue&type=template&id=27857c0d&scoped=true"
import script from "./kadarrespon.vue?vue&type=script&lang=js"
export * from "./kadarrespon.vue?vue&type=script&lang=js"
import style0 from "./kadarrespon.vue?vue&type=style&index=0&id=27857c0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27857c0d",
  null
  
)

export default component.exports